"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const plans = [{
  id: "starter",
  name: "Starter",
  price: "$20",
  description: "Perfect for a clean, professional site that just works.",
  ctaText: "Start free trial",
  ctaLink: "https://app.cynergia.co/sign-up?plan=starter",
  isFeatured: false
}, {
  id: "pro",
  name: "Pro",
  price: "$30",
  description: "Everything most small businesses need to grow online.",
  ctaText: "Start free trial",
  ctaLink: "https://app.cynergia.co/sign-up?plan=pro",
  isFeatured: true
}, {
  id: "business",
  name: "Business",
  price: "$99",
  description: "For shops, restaurants, and service businesses ready to scale.",
  ctaText: "Start free trial",
  ctaLink: "https://app.cynergia.co/sign-up?plan=business",
  isFeatured: false
}];
const planFeatures = [{
  planId: "starter",
  text: "AI-generated website"
}, {
  planId: "starter",
  text: "1 published site"
}, {
  planId: "starter",
  text: "Free Cynergia subdomain"
}, {
  planId: "starter",
  text: "Bilingual EN/ES"
}, {
  planId: "starter",
  text: "Mobile responsive"
}, {
  planId: "starter",
  text: "SSL certificate included"
}, {
  planId: "starter",
  text: "90+ PageSpeed performance"
}, {
  planId: "starter",
  text: "Basic contact forms"
}, {
  planId: "starter",
  text: "Email support"
}, {
  planId: "pro",
  text: "Everything in Starter"
}, {
  planId: "pro",
  text: "Custom domain included"
}, {
  planId: "pro",
  text: "Online reservations & bookings"
}, {
  planId: "pro",
  text: "Contact forms with email capture"
}, {
  planId: "pro",
  text: "Google Analytics integration"
}, {
  planId: "pro",
  text: "Meta Pixel integration"
}, {
  planId: "pro",
  text: "SEO optimization tools"
}, {
  planId: "pro",
  text: "Image generation (AI)"
}, {
  planId: "pro",
  text: "URL-to-site cloning"
}, {
  planId: "pro",
  text: "Priority email support"
}, {
  planId: "business",
  text: "Everything in Pro"
}, {
  planId: "business",
  text: "Full ecommerce (unlimited products)"
}, {
  planId: "business",
  text: "Online payments (Stripe, PayPal)"
}, {
  planId: "business",
  text: "Inventory management"
}, {
  planId: "business",
  text: "Booking calendar with payments"
}, {
  planId: "business",
  text: "Multilingual site (beyond EN/ES)"
}, {
  planId: "business",
  text: "Advanced SEO + schema markup"
}, {
  planId: "business",
  text: "Done-for-you site build (one-time)"
}, {
  planId: "business",
  text: "Priority phone & email support"
}, {
  planId: "business",
  text: "Dedicated account contact"
}];
export default function PricingCards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return;
}